import { DestroyRef, Directive, ElementRef, inject, NgZone, OnInit, output } from '@angular/core';

@Directive({
  selector: '[sbResizeObserver]',
})
export class ResizeObserverDirective implements OnInit {
  private elementRef = inject(ElementRef<HTMLElement>);
  private ngZone = inject(NgZone);
  private destroyRef = inject(DestroyRef);

  sbResizeObserver = output<ResizeObserverEntry>();

  ngOnInit(): void {
    const observer = new ResizeObserver(([entry]) => {
      this.ngZone.run(() => {
        this.sbResizeObserver.emit(entry);
      });
    });

    observer.observe(this.elementRef.nativeElement);

    this.destroyRef.onDestroy(() => {
      observer.disconnect();
    });
  }
}
